/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Manual_Removal_CloseInputs */

const en_delete_account_manual_removal_close = /** @type {(inputs: Delete_Account_Manual_Removal_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const es_delete_account_manual_removal_close = /** @type {(inputs: Delete_Account_Manual_Removal_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const ar_delete_account_manual_removal_close = /** @type {(inputs: Delete_Account_Manual_Removal_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Delete_Account_Manual_Removal_CloseInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_manual_removal_close = /** @type {((inputs?: Delete_Account_Manual_Removal_CloseInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Manual_Removal_CloseInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_manual_removal_close(inputs)
	if (locale === "es") return es_delete_account_manual_removal_close(inputs)
	return ar_delete_account_manual_removal_close(inputs)
});